module.exports = __webpack_public_path__ + "img/qrcode_wx.0b14c521.jpg";